module.exports = {
	CONEXION_BASE: process.env.REACT_APP_CONEXION_BASE,
	PORT: process.env.REACT_APP_PORT,
	PORT_ANTERIOR: process.env.REACT_APP_PORT_ANTERIOR,
	PRODUCT_NAME: process.env.REACT_APP_PRODUCT_NAME,
};
